"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VideoSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M30,22.8c0,1.1-.8,1.5-1.7,1l-2.6-1.6a4,4,0,0,1-1.7-3V12.8a4,4,0,0,1,1.7-3l2.6-1.6c.9-.5,1.7-.1,1.7,1Z"/><path d="M3.6,7A1.6,1.6,0,0,0,2,8.6V23.4A1.6,1.6,0,0,0,3.6,25H20.4A1.6,1.6,0,0,0,22,23.4V8.6A1.6,1.6,0,0,0,20.4,7ZM12,20a4,4,0,1,1,4-4A4,4,0,0,1,12,20Z"/>';
var VideoSVG = function VideoSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.VideoSVG = VideoSVG;
VideoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(VideoSVG);
exports.default = _default;